var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(require(("@/assets/svg/" + _vm.name + ".svg?inline")),_vm._b({tag:"Component",on:{"v-on":_vm.$listeners}},'Component',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }